"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfStipendCreateDto = instanceOfStipendCreateDto;
exports.StipendCreateDtoFromJSON = StipendCreateDtoFromJSON;
exports.StipendCreateDtoFromJSONTyped = StipendCreateDtoFromJSONTyped;
exports.StipendCreateDtoToJSON = StipendCreateDtoToJSON;
exports.StipendCreateDtoToJSONTyped = StipendCreateDtoToJSONTyped;
const StipendType_1 = require("./StipendType");
/**
 * Check if a given object implements the StipendCreateDto interface.
 */
function instanceOfStipendCreateDto(value) {
    if (!('stipendType' in value) || value['stipendType'] === undefined)
        return false;
    if (!('amount' in value) || value['amount'] === undefined)
        return false;
    return true;
}
function StipendCreateDtoFromJSON(json) {
    return StipendCreateDtoFromJSONTyped(json, false);
}
function StipendCreateDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'stipendType': (0, StipendType_1.StipendTypeFromJSON)(json['stipendType']),
        'amount': json['amount'],
    };
}
function StipendCreateDtoToJSON(json) {
    return StipendCreateDtoToJSONTyped(json, false);
}
function StipendCreateDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'stipendType': (0, StipendType_1.StipendTypeToJSON)(value['stipendType']),
        'amount': value['amount'],
    };
}
//# sourceMappingURL=StipendCreateDto.js.map